// Curriculum assessments (2026-10-18): a set built in Curriculum Connect from the lessons a class was
// taught. Same questions for everyone and graded on right answers like a practice set, but shown apart
// from practice sets everywhere teachers and students see sets (Sandy 2026-10-18). Every homework view
// the teacher and student APIs return carries `coverage` and `selectionVersion`; selectionVersion 5 is
// only ever a curriculum assessment.
export const isAssessment = (hw) => !!hw && (hw.coverage === 'curriculum' || Number(hw.selectionVersion) === 5);

// Splits a list of sets into { assessments, practice }, keeping each list's order.
export function splitAssessments(list) {
  const assessments = [];
  const practice = [];
  for (const hw of list || []) (isAssessment(hw) ? assessments : practice).push(hw);
  return { assessments, practice };
}
